<template>
  <div>
    <search-cpe-supplier-model @submit="submitSearch" />

    <div class="simiot-table-operation-buttons">
      <a-space>
        <a-button
          type="primary"
          @click="showNewModal"
          v-if="isShowMenu('cpe_supplier_models/new')"
        >新增</a-button>
      </a-space>
    </div>

    <a-table
      size="middle"
      :scroll="{ x: 'max-content' }"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="id"
    >
      <span slot="actions" slot-scope="text, record">
        <a-space>
          <a @click="showEditModal(record.id)" v-if="isHasEditPermission">编辑</a>
        </a-space>
      </span>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <new-cpe-supplier-model
      v-if="isShowNewModal"
      :visible.sync="isShowNewModal"
      :cpe-supplier-id="cpeSupplierId"
      @completed="fetchData"
    />

    <edit-cpe-supplier-model
      v-if="isShowEditModal"
      :visible.sync="isShowEditModal"
      :id="editingId"
      @completed="fetchData"
    />
  </div>
</template>

<script>
import { hasPermission } from '@/utils/permission'
import { findCpeSupplierModelsBySupplier } from '@/api/cpe_supplier_model'
import Pagination from '@/components/Pagination'
import SearchCpeSupplierModel from '@/views/cpe_supplier_models/Search'

export default {
  name: 'CpeSupplierModelList',
  components: {
    Pagination,
    SearchCpeSupplierModel,
    NewCpeSupplierModel: () => import('@/views/cpe_supplier_models/New'),
    EditCpeSupplierModel: () => import('@/views/cpe_supplier_models/Edit')
  },
  data() {
    return {
      data: [],
      columns: [
        {
          title: '采购型号',
          dataIndex: 'purchase_model',
          width: 180
        },
        {
          title: '对外展示型号',
          dataIndex: 'display_model',
          width: 180
        },
        {
          title: '状态',
          dataIndex: 'effective',
          width: 90
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          width: 200
        },
        {
          title: '创建时间',
          dataIndex: 'created_at',
          width: 170
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'actions',
          scopedSlots: { customRender: 'actions' }
        }
      ],
      loading: true,
      isShowNewModal: false,
      isShowEditModal: false,
      editingId: 0,
      pagination: {
        total_count: 0
      },
      query: {}
    }
  },
  computed: {
    cpeSupplierId() {
      return parseInt(this.$route.params.id)
    },
    isHasEditPermission() {
      return hasPermission('cpe_supplier_models/edit')
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    isShowMenu(menu) {
      return hasPermission(menu)
    },

    showNewModal() {
      this.isShowNewModal = true
    },

    showEditModal(id) {
      this.editingId = id
      this.isShowEditModal = true
    },

    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findCpeSupplierModelsBySupplier(this.cpeSupplierId, Object.assign({}, this.query)).then((res) => {
        this.data = res.data
        this.pagination = res.pagination
        this.loading = false
      })
    }
  }
}
</script>
